module.exports = __webpack_public_path__ + "img/fifa.d5ed003.png";